import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import logo from '../assets/logo180.png'; // Adjust path as needed
import '../styles.css'; // Import the global styles

export default function LoginPage() {
  const [password, setPassword] = useState('');
  const toast = useRef(null);
  const navigate = useNavigate();

  const handleLogin = () => {
    if (password === 'admin') {
      navigate('/customers');
    } else {
      toast.current.show({ severity: 'error', summary: 'Login Failed', detail: 'Incorrect password', life: 3000 });
    }
  };

  return (
    <div className="container">
      <div className="card">
        <div className="logoContainer">
          <img src={logo} alt="Logo" className="logo" />
        </div>
        <fieldset className="fieldset">
          <legend className="legend">Portal Login</legend>
          <div className="formGroup">
            <label htmlFor="password" className="label">
              Password <span className="required">*</span>
            </label>
            <InputText
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input"
              placeholder="Enter password"
            />
          </div>
          <Button
            label="Login"
            onClick={handleLogin}
            className="submitButton"
          />
        </fieldset>
      </div>
      <Toast ref={toast} />
    </div>
  );
}